module.exports = __webpack_public_path__ + "static/img/11.cd6b3ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/11.png
// module id = 7rbV
// module chunks = 4